import api from './axiosInstance';
export const getAll = () => api.get('/header-configs');
export const create = (data) => api.post('/header-configs', data);
export const update = (id, data) => api.put(`/header-configs/${id}`, data);
export const bulkReorder = (items) => api.put('/header-configs/bulk/reorder', { items });
export const remove = (id) => api.delete(`/header-configs/${id}`);
